import { Controller } from '@hotwired/stimulus'

export default class extends Controller {


  static targets = [
    'elemOffsetStart',
    'elemOffsetEnd',
    'beforeBtn',
    'afterBtn',
    'pages'
  ]


  static values = {
    itemPerPage: Number,
    currentPage: Number,
    totalPages: Number,
    currentNumberOfItems: Number,
    totalItems: Number
  }

  declare itemPerPageValue: number
  declare currentPageValue: number
  declare totalPagesValue: number
  declare currentNumberOfItemsValue: number
  declare totalItemsValue: number

  declare elemOffsetStartTarget: HTMLElement
  declare elemOffsetEndTarget: HTMLElement
  declare pagesTarget: HTMLElement
  declare beforeBtnTargets: HTMLElement[]
  declare afterBtnTargets: HTMLElement[]


  connect() {
    console.log('connect pagination controller')

    const elemOffsetStart = (this.currentPageValue - 1) * this.itemPerPageValue + 1
    this.elemOffsetStartTarget.innerHTML = elemOffsetStart.toString()

    const elemOffsetEnd = this.currentPageValue == this.totalPagesValue
      ? this.totalItemsValue
      : this.currentPageValue * this.itemPerPageValue
    this.elemOffsetEndTarget.innerHTML = elemOffsetEnd.toString()


    // construct pagination
    // previous is always shown but disabled if current page is 1
    // next is always shown but disabled if current page is last page

    if (this.currentPageValue == 1) {
      this.disable(this.beforeBtnTargets)
    }

    if (this.currentPageValue == this.totalPagesValue) {
      this.disable(this.afterBtnTargets)
    }


    // if there is < 8 pages in total : show all pages
    // page 1 : prev, [1], 2, 3, 4, 5, ..., 10, next
    // page 2 : prev, 1, [2], 3, 4, 5, ..., 10, next
    // page 3 : prev, 1, 2, [3], 4, 5, ..., 10, next
    // page 4 : prev, 1, 2, 3, [4], 5, ..., 10, next
    // page 5 : prev, 1, ... 4, [5], 6 ..., 10, next // because after the 5th page, we show 3 pages after the current page
    // page 6 : prev, 1, ... 5, [6], 7 ..., 10, next
    // page 7 : prev, 1, ... 6, [7], 8 , 9, 10, next  // because 7 + 3 = number of pages
    // page 8 : prev, 1, ... 6, 7, [8], 9 , 10, next
    // ...


    let pagination = ''

    if (this.totalPagesValue < 8) {
      for (let i = 1; i <= this.totalPagesValue; i++) {
        pagination += this.page(i, i == this.currentPageValue)
      }
    } else {
      if (this.currentPageValue < 5) {
        for (let i = 1; i <= 5; i++) {
          pagination += this.page(i, i == this.currentPageValue)
        }
        pagination += this.middle()
        pagination += this.page(this.totalPagesValue, false)
      } else if (this.currentPageValue > this.totalPagesValue - 4) {
        pagination += this.page(1, false)
        pagination += this.middle()
        for (let i = this.totalPagesValue - 4; i <= this.totalPagesValue; i++) {
          pagination += this.page(i, i == this.currentPageValue)
        }
      } else {
        pagination += this.page(1, false)
        pagination += this.middle()
        for (let i = this.currentPageValue - 1; i <= this.currentPageValue + 1; i++) {
          pagination += this.page(i, i == this.currentPageValue)
        }
        pagination += this.middle()
        pagination += this.page(this.totalPagesValue, false)
      }
    }

    this.pagesTarget.querySelector('#previous').insertAdjacentHTML('afterend', pagination)
  }


  page(pageNumber: number, current: boolean) {
    let classCurrent = `relative z-10 inline-flex items-center bg-blue-600 px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600`
    let classNormal = `relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0`
    return `<a 
href="javascript:void(0)"
hx-get="${this.link(pageNumber)}" hx-replace-url="true" hx-target="#posts"
hx-swap="outerHTML show:#posts:top" hx-select="#posts"
class="${current ? classCurrent : classNormal}">
                  ${pageNumber}
            </a>
`
  }

  middle() {
    return `<span class="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300 focus:outline-offset-0">...</span>`
  }

  disable(targets: HTMLElement[]) {
    setTimeout(() => {
      targets.forEach((elem) => {
        elem.classList.add('cursor-not-allowed')
        elem.classList.forEach((value) => {
          if (value.startsWith('hover')) {
            elem.classList.remove(value)
          }
        })
        elem.removeAttribute('href')
      })
    }, 100)
  }


  link(page: number) {
    let currentURL = new URL(window.location.href)
    const alreadyHavePagePathParameterRegexp = new RegExp('/page/[0-9]+')
    // if alreadyHavePagePathParameterRegexp is found in the current URL we replace it with the new page number
    // else we add the page parameter

    if (alreadyHavePagePathParameterRegexp.test(currentURL.pathname)) {
      currentURL.pathname = currentURL.pathname.replace(alreadyHavePagePathParameterRegexp, '/page/' + page)
    } else {
      currentURL.pathname = currentURL.pathname + '/page/' + page
    }


    return currentURL.href
  }


}
